export class SetKeepFilters {
    public static readonly type = "[Projects] Save keep filters";

    constructor(public payload: boolean) {}
}
